import styles from './Toolbar.module.css';

import trianglePlay from 'assets/svg/triangle-01.svg';
import infoIcon from 'assets/svg/icon_info-01.svg';

import RegularButton from 'ui/RegularButton';
import Tag from 'ui/Tag';
import Icon from 'ui/Icon';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import useAlert from 'hooks/useAlert';
import { useState } from 'react';
import ForceCompleteModal from '../ForceCompleteModal';
import Tooltip from 'ui/Tooltip';
import { STATUS_CONFIG, StatusIteration } from 'consts/scheme.consts';
import { productionStore } from 'store/mobx/production.store';
import { projectsStore } from 'store/mobx/projects.store';
import { downloadIterationReport } from '../../../../../../services/projects.services';

const Toolbar = observer(() => {
  const { showAlert } = useAlert();
  const { selectedProductionData, startIteration } = productionStore;
  const { setIteration } = projectsStore;
  const statusInfo = STATUS_CONFIG[selectedProductionData?.status];
  const [loader, setLoader] = useState(false);
  const [openForceCompleteModal, setOpenForceCompleteModal] = useState(false);

  const handleStartIteration = async () => {
    setLoader(true);
    const result = await startIteration();
    await setIteration();
    if (!result.status) {
      errorCommonAlert(result.errorCode, result.message);
      setLoader(false);
      return;
    }
    setLoader(false);
  };

  const handleForceCompleteIteration = () => {
    setOpenForceCompleteModal(true);
  };

  const handleDownloadReport = async () => {
    await downloadIterationReport(selectedProductionData.id);
  };

  const errorCommonAlert = (code, message) => showAlert(`Код № ${code}. ${message}!`, 'error');

  return (
    <div className={styles.toolbar}>
      {selectedProductionData?.status === StatusIteration.NotStarted && (
        <RegularButton
          className={styles.batton}
          text={'Запуск'}
          onClick={handleStartIteration}
          variant={'outlined'}
          disabled={selectedProductionData?.status !== StatusIteration.NotStarted || loader}
          appendIcon={<Icon className={styles.icon} src={trianglePlay} />}
        />
      )}
      {selectedProductionData?.status === StatusIteration.InProgress && (
        <RegularButton
          className={classNames(styles.batton, styles.battonWidth)}
          color="error"
          text={'Принудительно завершить'}
          onClick={handleForceCompleteIteration}
          variant={'flat'}
          disabled={selectedProductionData?.status !== StatusIteration.InProgress || loader}
        />
      )}
      {selectedProductionData?.status !== StatusIteration.NotStarted && (
        <RegularButton
          className={styles.batton}
          text={'Отчет'}
          color={'secondary'}
          onClick={handleDownloadReport}
          variant={'flat'}
        />
      )}
      {statusInfo?.text && (
        <div className={classNames(styles.wrapperTitle, styles.noBorderLeft)}>
          <div className={classNames(styles.textAuxiliary, styles.txtBlack16)}>{'Статус: '}</div>
          {statusInfo?.text && (
            <Tooltip
              styleConfig={{ tooltip: styles.tooltipContent }}
              text={
                selectedProductionData?.status === StatusIteration.ForceCompleted &&
                selectedProductionData.description
              }
            >
              <Tag
                icon={selectedProductionData?.status === StatusIteration.ForceCompleted && infoIcon}
                text={statusInfo?.text}
                color={statusInfo?.color}
                variant="flat"
              />
            </Tooltip>
          )}
        </div>
      )}
      {selectedProductionData?.creator?.fio && (
        <>
          <div className={styles.textMain}>Поручил:</div>
          <div className={styles.person}>{selectedProductionData?.creator?.fio}</div>
        </>
      )}
      <div className={styles.wrapperTitle}>
        {selectedProductionData?.project?.code && (
          <Tag
            text={selectedProductionData?.project?.code}
            color={'secondary'}
            variant="outlined"
          />
        )}
        <div className={styles.textAuxiliary}>{selectedProductionData?.project?.name}</div>
      </div>
      <ForceCompleteModal open={openForceCompleteModal} setOpen={setOpenForceCompleteModal} />
    </div>
  );
});

export default Toolbar;
